// extracted by mini-css-extract-plugin
export default {"col":"ShiftLeft_col__2xl0Y","arrow":"ShiftLeft_arrow__F-Y+c","lists":"ShiftLeft_lists__U1ds8","first":"ShiftLeft_first__DT6If"};